/**
 * Title/description/path for the three revision-surgery spoke pages.
 *
 * These four fields are the only part of a spoke that a route's `head()`
 * needs outside of server rendering. They live in their own tiny module so
 * the full content model in `revision-spokes.ts` — every paragraph of body
 * copy for all three pages — stays out of the shared client bundle that
 * every visitor downloads. `revision-spokes.ts` spreads these back in, so
 * this file remains the single source of truth for the four fields.
 */

export type RevisionSlug = "sleeve" | "gastric-bypass" | "lap-band" | "tore";

export type RevisionSpokeMeta = {
  slug: RevisionSlug;
  path: string;
  title: string;
  description: string;
};

export const REVISION_SPOKE_META: Record<RevisionSlug, RevisionSpokeMeta> = {
  sleeve: {
    slug: "sleeve",
    path: "/services/revisions/sleeve",
    title: "Gastric Sleeve Revision Surgery in Virginia | Virginia Bariatric",
    description:
      "Gastric sleeve revision in Virginia for weight regain or reflux: sleeve-to-bypass, re-sleeve, SADI and duodenal switch. Costs, insurance, and what to expect.",
  },
  "gastric-bypass": {
    slug: "gastric-bypass",
    path: "/services/revisions/gastric-bypass",
    title: "Gastric Bypass Revision & TORe in Virginia | Virginia Bariatric",
    description:
      "Gastric bypass revision surgery in Virginia with Dr. Matthew Fitzer. Endoscopic TORe, pouch revision, and distalization for weight regain after Roux-en-Y bypass.",
  },
  "lap-band": {
    slug: "lap-band",
    path: "/services/revisions/lap-band",
    title: "LAP-BAND Removal & Revision in Virginia | Virginia Bariatric",
    description:
      "LAP-BAND removal and revision surgery in Virginia. Dr. Fitzer removes slipped, eroded, or ineffective gastric bands and converts patients to sleeve or bypass.",
  },
  tore: {
    slug: "tore",
    path: "/services/revisions/tore",
    title: "TORe for Weight Regain After Bypass in Virginia | Virginia Bariatric",
    description:
      "Transoral outlet reduction (TORe) in Northern Virginia: an outpatient, incisionless endoscopic procedure for weight regain after gastric bypass, performed by Dr. Matthew Fitzer.",
  },
};
